import {Component, Inject, Optional} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

function noWhitespaceOnly(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value ?? '';
  return value.trim().length === 0 && value.length > 0 ? {whitespace: true} : null;
}

@Component({
  selector: 'app-commission-tab-dialog',
  templateUrl: './commission-tab-dialog.component.html',
  styleUrl: './commission-tab-dialog.component.scss'
})
export class CommissionTabDialogComponent {

  form: FormGroup;
  isEdit: boolean = false;

  constructor(
    private readonly dialogRef: MatDialogRef<CommissionTabDialogComponent>,
    private readonly fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { name: string } | null
  ) {
    this.isEdit = !!data?.name;
    this.form = this.fb.group({
      name: [data?.name || '', [Validators.required, Validators.minLength(2), noWhitespaceOnly]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      if (this.isEdit) {
        this.dialogRef.close({name: this.form.value.name});
      } else {
        this.dialogRef.close({
          name: this.form.value.name,
          applyToAllStandard: false,
          applyToAllExtra: false,
          globalStandardValue: 0,
          globalStandardUnit: '%',
          globalExtraValue: 0,
          globalExtraUnit: '%',
          methods: []
        });
      }
    }
  }
}
